import React from 'react';

interface LoadingButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  spinnerSize?: number;
  spinnerColor?: string;
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading = false,
  spinnerSize = 20,
  spinnerColor = 'var(--secondary-shade-2)',
  children,
  disabled,
  ...props
}) => {
  return (
    <button
      {...props}
      disabled={loading || disabled}
      style={{
        position: 'relative',
        pointerEvents: loading ? 'none' : undefined,
        opacity: loading ? 0.7 : 1,
        ...props.style,
      }}
    >
      {/* Button content fades out when loading for clarity */}
      <span
        style={{
          opacity: loading ? 0.3 : 1,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          gap: '10px',
        }}
      >
        {children}
      </span>
      {loading && (
        <span
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2,
          }}
        >
          <div
            className="spinner"
            style={{
              width: spinnerSize,
              height: spinnerSize,
              borderWidth: 3,
              borderLeftColor: spinnerColor,
            }}
          />
        </span>
      )}
    </button>
  );
};

export default LoadingButton;
